// This file is used to map the fields for the OAP Sepio Form
import { getOapFieldNames } from '@/components/documents/Foxit/FormMapping/FieldNameProviders/OAPFieldNameProvider'
import { useFormFillHelper } from '@/components/documents/Foxit/FormMapping/composables/FormFillHelper'
import { useIdentitySetup } from '@/components/documents/Foxit/FormMapping/composables/IdentityFields'

export default class Oap {
	private fieldNameProvider = getOapFieldNames()

	// Standard list of fields for this form.
	// These values point to field names in the fieldNameProvider,
	// as well as functions to get the value for the field via the fieldValueProvider
	private fields: (keyof typeof this.fieldNameProvider)[] = [
		'funeralHomeName',
		'funeralHomeCityState',
		'agentName',
		'agentProducerNumber',
	]
	private unfilledFields = [
		'funeralHomeRepresentativeSignature',
		'funeralHomeRepresentativeSignatureDate',
	]

	// Setup prior to building form filling array.
	constructor(planHolderId: string) {
		const { identitySetup } = useIdentitySetup()
		const { setFieldNameProvider } = useFormFillHelper()

		identitySetup(planHolderId, ['funeralHome', 'salesContact'])
		setFieldNameProvider(this.fieldNameProvider)
	}

	// Build form filling array.
	getFormMappings() {
		const { mapFields } = useFormFillHelper()

		return mapFields(this.fields)
	}
}
